import * as React from 'react'
import { withRouter, NavLink } from 'react-router-dom'
import ConfigStore from '../../Stores/ConfigStore'
import { observer } from 'mobx-react'
import { INavItem } from '../../Model/Nav'
import LocalizationStore from '../../Stores/LocalizationStore'
import { history } from '../../Routing'
import QuestionnaireCreate from './Questionnaire/QuestionnaireCreateView'
import UserStore from '../../Stores/UserStore'
import PaymentCreate from './Payment/PaymentCreateView'
import ProxyCacheClear from './ProxyCacheClear'

@observer
class LeftMenuView extends React.Component<any> {

    config = ConfigStore.getInstance()
    nav = this.config.nav
    us = UserStore.getInstance()

    opened: boolean
    constructor(props: any) {
        super(props)
    }

    toggle(e: any, context: LeftMenuView, toClose?: Boolean) {
        this.config.toggleLeftBar(toClose)
    }

    new() {
        history.push('/questionnaire')
    }

    checkHidden() {
        return !UserStore.getInstance().checkSession || this.nav.items.length < 2
    }

    render() {
        let ls = LocalizationStore.getInstance()
        let us = UserStore.getInstance()

        const self = this

        return (
            <div
                className={`left-menu ${this.config.toggledLeftBarClass}`}
                hidden={this.checkHidden()}
            >
                <div className="menu-items">
                    <ul className="leftMenuItems">
                        {this.nav.items.map(function (item: INavItem, i: number) {
                            return (
                                <li role="presentation" className="nav item" key={i}>
                                    <NavLink
                                        onClick={(e) => self.toggle(e, self, true)}
                                        to={item.link}
                                        className={item.className}
                                        data-toggle="tooltip"
                                        data-placement="bottom"
                                        title={ls.t(item.title)}
                                    >
                                        <span className="label">{ls.t!(item.label)}</span>
                                    </NavLink>
                                </li>
                            )
                        })}
                    </ul>
                    <div
                        onClick={(e) => self.toggle(e, self, true)}
                        hidden={!(us.checkAdmin || us.checkCreditConsultant || us.checkSuperAdmin)}
                    >
                        <QuestionnaireCreate />
                    </div>
                    <div
                        onClick={(e) => self.toggle(e, self, true)}
                        hidden={!(us.checkAdmin || us.checkCashier || us.checkCashierAdmin || us.checkSuperAdmin)}
                    >
                        <PaymentCreate />
                    </div>

                    <div
                        onClick={(e) => self.toggle(e, self, true)}
                        hidden={!(us.checkSuperAdmin)}
                    >
                        <ProxyCacheClear />
                    </div>
                </div>
            </div>
        )
    }
}

export default withRouter(LeftMenuView)


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Views/PartialViews/LeftMenuView.tsx